<template>
  <ExamDo @submit="onSubmit" :isFile="22" :practiceType="6">
    <template v-slot:bread>
      <div class="bread">
        <ExamIndexBread></ExamIndexBread>
        <span class="slash">/</span>
        <span class="current">自由组卷</span>
      </div>
    </template>
  </ExamDo>
</template>
<script>
import ExamDo from './components/ExamDo.vue';
import ExamIndexBread from './components/ExamIndexBread.vue';

export default {
  name: 'ExamFreedomDo',
  components: {
    ExamDo,
    ExamIndexBread,
  },
  methods: {
    onSubmit() {
      this.$router.replace({
        name: 'ExamFreedomReport',
        query: {
          id: this.$route.query.id,
        },
      });
    },
  },
};
</script>
